import { apiServer } from 'settings/web-services/api';

export function getAccessToken(data: { Token: string }) {
  return apiServer.post(`/auth/external/accessToken`, data);
}
